import React, { useContext } from "react";
import TitleWithToggle from "features/bots/BotForm/common/TitleWithToggle";
import EqualColumnsGrid from "common/Grids/EqualColumnsGrid";
import SliderAndInput from "features/configuration/GeneralConfiguration/ConfigurationItem/StrategyItem/SliderAndInput";
import { HelperTooltip } from "common/Tooltips/HelperTooltip";
import { useStrategyPrices } from "@shared/features/bots/BotForm/common/hooks";
import MaxPriceDifference from "features/bots/BotForm/Strategies/MaxPriceDifference";
import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import { BotType } from "@shared/types";
import {
  STRATEGY_PRICE_DIFFERENCE_INPUT_ID,
  STRATEGY_PRICE_SCALE_INPUT_ID,
} from "testIds.ts";

const StrategyPrices = () => {
  const { botType } = useContext(BotFormContext)!;
  const {
    toggleFieldData,
    priceDifferenceSelectorData,
    priceScaleSelectorData,
    singleColumnLayout,
  } = useStrategyPrices();

  const priceDifferenceSelector = priceDifferenceSelectorData ? (
    <SliderAndInput
      key={priceDifferenceSelectorData.title}
      name={priceDifferenceSelectorData.title}
      value={priceDifferenceSelectorData.value}
      setValue={priceDifferenceSelectorData.onChange}
      maxValue={priceDifferenceSelectorData.maxValue}
      minValue={priceDifferenceSelectorData.minValue}
      step={priceDifferenceSelectorData.step}
      showError={priceDifferenceSelectorData.showError}
      precision={priceDifferenceSelectorData.precision}
      suffix={priceDifferenceSelectorData.suffix}
      placeholder={priceDifferenceSelectorData.placeholder}
      inputTestId={STRATEGY_PRICE_DIFFERENCE_INPUT_ID}
      useDebounce={true}
      helperTooltip={
        <HelperTooltip {...priceDifferenceSelectorData.helperTooltipData} />
      }
    />
  ) : undefined;

  const priceScaleSelector = priceScaleSelectorData?.show ? (
    <SliderAndInput
      inputTestId={STRATEGY_PRICE_SCALE_INPUT_ID}
      key={priceScaleSelectorData.title}
      name={priceScaleSelectorData.title}
      value={priceScaleSelectorData.value}
      setValue={priceScaleSelectorData.onChange}
      maxValue={priceScaleSelectorData.maxValue}
      minValue={priceScaleSelectorData.minValue}
      showError={priceScaleSelectorData.showError}
      step={priceScaleSelectorData.step}
      precision={priceScaleSelectorData.precision}
      placeholder={priceScaleSelectorData.placeholder}
      wait={priceScaleSelectorData.wait}
      useDebounce={true}
      helperTooltip={
        <HelperTooltip {...priceScaleSelectorData.helperTooltipData} />
      }
    />
  ) : undefined;

  const priceInputs = [priceDifferenceSelector, priceScaleSelector];
  const isHedgingBot = botType === BotType.HEDGING;

  if (toggleFieldData.isToggleField && !isHedgingBot) {
    return (
      <div style={{ marginBottom: 16 }}>
        <TitleWithToggle
          title={toggleFieldData.title}
          content={
            <EqualColumnsGrid
              numColumns={singleColumnLayout ? 1 : 2}
              style={{ marginBottom: -8, paddingLeft: 4 }}
              rowGap={4}
            >
              {priceInputs}
            </EqualColumnsGrid>
          }
          fieldType={toggleFieldData.fieldType}
        />
        <MaxPriceDifference />
      </div>
    );
  }

  return <>{priceInputs}</>;
};

export default StrategyPrices;
